import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ComparedOptions } from '../common/compared-options';

export class DateRange extends React.PureComponent {
  static defaultProps = {
    label: '',
    start: '',
    end: '',
    onChangeSelectOption: null,
    onStartInputChange: null,
    onEndInputChange: null,
    onStartChangeComplete: null,
    onEndChangeComplete: null,
    selectedOption: undefined,
    highlightInputIndex: -1,
  }

  constructor(props) {
    super(props);
    this.startRef = React.createRef();
    this.endRef = React.createRef();
  }

  componentDidUpdate() {
    if (this.props.highlightInputIndex !== 0) {
      this.startRef.current.blur();
    }

    if (this.props.highlightInputIndex !== 1) {
      this.endRef.current.blur();
    }
  }

  onStartInputKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.onStartChangeDone(event);
    }
  }

  onEndInputKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.onEndChangeDone(event);
    }
  }

  onStartChangeDone = (event) => {
    this.props.onStartChangeComplete(event);
  }

  onEndChangeDone = (event) => {
    this.props.onEndChangeComplete(event);
  }

  render() {
    return (
      <div className="date-range">
        {(!this.props.selectedOption || _.size(ComparedOptions) < 1) && (<span className="date-range-label">{this.props.label}</span>)}
        {this.props.selectedOption && _.size(ComparedOptions) >= 1 && (
        <select
          className="date-range-label"
          onChange={this.props.onChangeSelectOption}
          value={this.props.selectedOption.type}
        >
          {_.map(ComparedOptions, (option, key) =>
            (
              <option key={key} value={option.type}>
                {this.props.i18n.getString(option.textToShow)}
              </option>
            ))}
        </select>)}
        <input
          type="text"
          className={classNames('start', { highlight: this.props.highlightInputIndex === 0 })}
          value={this.props.start}
          onKeyDown={this.onStartInputKeyDown}
          onChange={this.props.onStartInputChange}
          onBlur={this.onStartChangeDone}
          onFocus={() => this.props.onInputFocus(0)}
          ref={this.startRef}
          aria-label={this.props.startDateAriaLabel}
        />
        <p> - </p>
        <input
          type="text"
          className={classNames('end', { highlight: this.props.highlightInputIndex === 1 })}
          value={this.props.end}
          onKeyDown={this.onEndInputKeyDown}
          onChange={this.props.onEndInputChange}
          onBlur={this.onEndChangeDone}
          onFocus={() => this.props.onInputFocus(1)}
          ref={this.endRef}
          aria-label={this.props.endDateAriaLabel}
        />
      </div>
    );
  }
}

DateRange.propTypes = {
  label: PropTypes.string,
  onChangeSelectOption: PropTypes.func,
  onStartInputChange: PropTypes.func,
  onEndInputChange: PropTypes.func,
  onStartChangeComplete: PropTypes.func,
  onEndChangeComplete: PropTypes.func,
  selectedOption: PropTypes.shape({
    type: PropTypes.number,
    keyToExport: PropTypes.string,
    textToShow: PropTypes.string,
    textToExport: PropTypes.string,
    get: PropTypes.func,
  }),
  start: PropTypes.string,
  end: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  highlightInputIndex: PropTypes.number,
  onInputFocus: PropTypes.func.isRequired,
  startDateAriaLabel: PropTypes.string.isRequired,
  endDateAriaLabel: PropTypes.string.isRequired,
};
